import React, { useState } from 'react';
import { Hero } from '../components/Hero';
import { Welcome } from '../components/Welcome';
import { Schedule } from '../components/Schedule';
import { Location } from '../components/Location';
import { RSVPForm } from '../components/RSVPForm';
import { Footer } from '../components/Footer';
import { LockIcon } from 'lucide-react';
const PASSWORD = 'kanfamily';
export function Reunion() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === PASSWORD) {
      setIsUnlocked(true);
      setError(false);
    } else {
      setError(true);
    }
  };
  if (!isUnlocked) {
    return <div className="min-h-screen bg-paper flex items-center justify-center px-6" data-id="element-129">
        <form onSubmit={handleSubmit} className="w-full max-w-sm text-center space-y-6" data-id="element-130">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-terracotta/10 text-terracotta mb-2" data-id="element-131">
            <LockIcon className="w-6 h-6" data-id="element-132" />
          </div>
          <h2 className="text-3xl text-ink" data-id="element-133">Enter Password</h2>
          <p className="text-ink-light text-sm" data-id="element-134">
            This page is for family members only.
          </p>
          <input type="password" value={password} onChange={e => {
          setPassword(e.target.value);
          setError(false);
        }} placeholder="Password" className="w-full px-4 py-3 bg-paper-alt border border-ink/10 rounded-sm focus:outline-none focus:ring-2 focus:ring-terracotta/50 focus:border-terracotta transition-colors text-center text-lg" autoFocus data-id="element-135" />
          {error && <p className="text-sm text-red-500" data-id="element-136">
              Incorrect password. Please try again.
            </p>}
          <button type="submit" className="w-full bg-terracotta text-white py-3 rounded-sm text-lg transition-all hover:bg-[#A85D45]" data-id="element-137">
            Enter
          </button>
        </form>
      </div>;
  }
  return <div className="min-h-screen bg-paper font-serif text-ink selection:bg-terracotta/20 selection:text-terracotta" data-id="element-138">
      <Hero data-id="element-139" />
      <Welcome data-id="element-140" />
      <Schedule data-id="element-141" />
      <Location data-id="element-142" />
      <RSVPForm data-id="element-143" />
      <Footer data-id="element-144" />
    </div>;
}